import axios, { AxiosInstance, AxiosResponse, AxiosError } from 'axios';

// Support both Next.js and CRA environment variable patterns
const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || process.env.REACT_APP_API_BASE_URL;

const axiosInstance: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

if (typeof window !== 'undefined') {
  console.log(`API_BASE_URL: ${API_BASE_URL}`);
}

const axiosInstanceNoInterceptors: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

// Redirect to login on 401
axiosInstance.interceptors.response.use(
  // Success handler
  (response: AxiosResponse) => {
    return response;
  },
  // Error handler
  (error: AxiosError) => {
    // Catch canceled requests
    if (axios.isCancel(error)) {
      console.log(error);
      return {};
    }

    // Handle 401 unauthorized
    if (error.response && error.response.status === 401) {
      if (typeof window !== 'undefined' && !window.location.href.includes('/login')) {
        const currentPath = window.location.pathname + window.location.search;
        window.location.href = `/login?next=${encodeURIComponent(currentPath)}`;
        return;
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
export { axiosInstanceNoInterceptors };
